var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1114,
    height: 613,
    viewBox: "0 0 1114 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-130.614 -8.15077L-91.9387 -72.9427L-16.4895 -74.0407L20.2552 -10.397L-18.4202 54.3949L-93.8694 55.4929L-130.614 -8.15077Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.8166 -74.4292L22.8589 -139.221L98.3081 -140.319L135.053 -76.6754L96.3773 -11.8835L20.9281 -10.7855L-15.8166 -74.4292Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-59.6235 379.922L-20.948 315.13L54.5012 314.032L91.2459 377.676L52.5704 442.468L-22.8788 443.566L-59.6235 379.922Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1741 313.644L93.8495 248.852L169.299 247.754L206.043 311.398L167.368 376.19L91.9188 377.288L55.1741 313.644Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.972 247.366L208.647 182.574L284.096 181.476L320.841 245.119L282.166 309.911L206.716 311.009L169.972 247.366Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284.769 181.087L323.445 116.295L398.894 115.197L435.639 178.841L396.963 243.633L321.514 244.731L284.769 181.087Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M399.567 114.809L438.242 50.0168L513.691 48.9188L550.436 112.562L511.761 177.354L436.311 178.452L399.567 114.809Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M514.364 48.5303L553.04 -16.2617L628.489 -17.3597L665.234 46.2841L626.558 111.076L551.109 112.174L514.364 48.5303Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M629.162 -17.7481L667.837 -82.54L743.287 -83.638L780.031 -19.9943L741.356 44.7977L665.907 45.8957L629.162 -17.7481Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M743.959 -84.0265L782.635 -148.818L858.084 -149.916L894.829 -86.2727L856.153 -21.4808L780.704 -20.3828L743.959 -84.0265Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-94.6672 185.625L-55.9917 120.833L19.4575 119.735L56.2022 183.379L17.5267 248.171L-57.9225 249.269L-94.6672 185.625Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1304 119.347L58.8059 54.555L134.255 53.457L171 117.101L132.324 181.893L56.8751 182.991L20.1304 119.347Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.928 53.0685L173.603 -11.7235L249.053 -12.8215L285.797 50.8223L247.122 115.614L171.673 116.712L134.928 53.0685Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.726 -13.21L288.401 -78.0019L363.85 -79.0999L400.595 -15.4562L361.919 49.3357L286.47 50.4337L249.726 -13.21Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M364.523 -79.4883L403.199 -144.28L478.648 -145.378L515.392 -81.7345L476.717 -16.9426L401.268 -15.8446L364.523 -79.4883Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-170.199 56.8869L-131.524 -7.90497L-56.0748 -9.00297L-19.3301 54.6407L-58.0056 119.433L-133.455 120.531L-170.199 56.8869Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.4019 -9.3915L-16.7264 -74.1834L58.7228 -75.2814L95.4675 -11.6377L56.792 53.1542L-18.6572 54.2522L-55.4019 -9.3915Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3956 -75.6698L98.0711 -140.462L173.52 -141.56L210.265 -77.916L171.59 -13.1241L96.1403 -12.0261L59.3956 -75.6698Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-99.2089 444.96L-60.5334 380.168L14.9158 379.07L51.6605 442.714L12.985 507.505L-62.4642 508.603L-99.2089 444.96Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5886 378.681L54.2641 313.89L129.713 312.792L166.458 376.435L127.783 441.227L52.3333 442.325L15.5886 378.681Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.386 312.403L169.062 247.611L244.511 246.513L281.256 310.157L242.58 374.949L167.131 376.047L130.386 312.403Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M245.184 246.125L283.859 181.333L359.308 180.235L396.053 243.878L357.378 308.67L281.928 309.768L245.184 246.125Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M359.981 179.846L398.657 115.054L474.106 113.956L510.851 177.6L472.175 242.392L396.726 243.49L359.981 179.846Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M474.779 113.568L513.454 48.7759L588.904 47.6779L625.648 111.322L586.973 176.114L511.524 177.212L474.779 113.568Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M589.576 47.2894L628.252 -17.5025L703.701 -18.6005L740.446 45.0432L701.77 109.835L626.321 110.933L589.576 47.2894Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M704.374 -18.9889L743.049 -83.7808L818.499 -84.8788L855.243 -21.2351L816.568 43.5568L741.119 44.6548L704.374 -18.9889Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M819.172 -85.2673L857.847 -150.059L933.296 -151.157L970.041 -87.5136L931.365 -22.7216L855.916 -21.6236L819.172 -85.2673Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-134.252 250.662L-95.5764 185.87L-20.1272 184.772L16.6175 248.416L-22.058 313.208L-97.5072 314.306L-134.252 250.662Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-19.4544 184.384L19.2211 119.592L94.6703 118.494L131.415 182.138L92.7395 246.929L17.2904 248.027L-19.4544 184.384Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3432 118.105L134.019 53.3134L209.468 52.2154L246.213 115.859L207.537 180.651L132.088 181.749L95.3432 118.105Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M210.141 51.8269L248.816 -12.965L324.265 -14.063L361.01 49.5807L322.335 114.373L246.885 115.471L210.141 51.8269Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M324.938 -14.4516L363.614 -79.2435L439.063 -80.3415L475.808 -16.6978L437.132 48.0942L361.683 49.1922L324.938 -14.4516Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M439.736 -80.73L478.411 -145.522L553.861 -146.62L590.605 -82.9762L551.93 -18.1843L476.481 -17.0863L439.736 -80.73Z",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternLight);
export default __webpack_public_path__ + "static/media/bg-pattern-light.7b1c2cbed0937795fa47a52995275105.svg";
export { ForwardRef as ReactComponent };